import { apiClient } from '@/services/ApiClient.js'

import { UPLOAD_DOCUMENT_TYPE } from '@/constants/constants'

export default {
  getDocument(quotationId, documentId) {
    return apiClient
      .get(`tarfin-pro-quotations/${quotationId}/documents/${documentId}`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  uploadDocument(quotationId, documentId, file) {
    let formData = new FormData()
    formData.append('payload[file]', file)
    formData.append('payload[type]', UPLOAD_DOCUMENT_TYPE.SIGNED)

    return apiClient
      .postForm(`tarfin-pro-quotations/${quotationId}/documents/${documentId}/upload`, formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  viewSignedDocument(documentId, mimeType) {
    return apiClient
      .get(`tarfin-pro-quotations/view-signed-document/${documentId}`, {
        responseType: 'arraybuffer'
      })
      .then(response => {
        let blob = new Blob([response], { type: mimeType })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  viewOriginalDocument(documentId) {
    return apiClient
      .get(`tarfin-pro-quotations/view-original-document/${documentId}`, {
        responseType: 'arraybuffer'
      })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  rejectDocument(documentId, rejectionReason, rejectionReasonDescription) {
    return apiClient
      .patch(`tarfin-pro-quotations/reject-signed-document/${documentId}`, {
        payload: {
          rejection_reason: rejectionReason,
          rejection_reason_description: rejectionReasonDescription
        }
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  approveDocument(documentId) {
    return apiClient
      .patch(`tarfin-pro-quotations/approve-signed-document/${documentId}`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createDocuments(quotationId) {
    return apiClient
      .post(`tarfin-pro-quotations/${quotationId}/documents`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  destroyDocument(documentId) {
    return apiClient
      .delete(`tarfin-pro-quotations/destroy-promissory-note/${documentId}`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  viewDeletedDocument(documentId, mimeType) {
    return apiClient
      .get(`tarfin-pro-quotations/view-deleted-signed-promissory-note-document/${documentId}`, {
        responseType: 'arraybuffer'
      })
      .then(response => {
        let blob = new Blob([response], { type: mimeType })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  }
}
